module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "fm4"
    }
  }, [_c('p', [_vm._v("Acknowledgments are due to everyone at AMIP Thornton Heath, especially DSupt D. Reeve and PC M. Little. Also Iain West of the Forensic Pathology Department, Guy’s Hospital, Dr. Elizabeth Wilson and Doug Stowton of the Forensic Science Services, Zeno Geradts, and pathologist Ed Friedlander, University of Health, Missouri, all of whom were professional and supportive beyond the call of duty.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A special mention to DCI Steve Gwilliam for his patience and help.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("For their friendship and their faith in me: Jimmy Brooks, Karen Catling, Rilke D., Linda Downing, Jon Fink, Jo Goldsworthy, Jane Gregory, Dave and Deborah Head, Patrick Janson-Smith, Sue and Michael Laydon, Doreen Norman, Lisanne Radice, Sam Serafy, and Simon Taylor. Thank you also to Caroline Shanks, who saved my life years ago, to Mairi Hitomi, who continues to do so, to my truly outstanding and wonderful family (the most educated and resourceful bunch of people I have ever encountered), and, most of all, to Keith Quinn.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cdca038","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acknowledgement.vue
// module id = 72
// module chunks = 0